var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#1A496D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 18.6665L27.1061 33.9077C28.8692 35.1419 29.7508 35.759 30.7097 35.998C31.5567 36.2091 32.4426 36.2091 33.2896 35.998C34.2485 35.759 35.1301 35.1419 36.8932 33.9077L58.6663 18.6665M18.133 53.3332H45.8663C50.3468 53.3332 52.587 53.3332 54.2983 52.4612C55.8036 51.6942 57.0274 50.4704 57.7944 48.9651C58.6663 47.2538 58.6663 45.0136 58.6663 40.5332V23.4665C58.6663 18.9861 58.6663 16.7459 57.7944 15.0346C57.0274 13.5293 55.8036 12.3054 54.2983 11.5385C52.587 10.6665 50.3468 10.6665 45.8663 10.6665H18.133C13.6526 10.6665 11.4124 10.6665 9.70108 11.5385C8.19579 12.3054 6.97194 13.5293 6.20496 15.0346C5.33301 16.7459 5.33301 18.9861 5.33301 23.4665V40.5332C5.33301 45.0136 5.33301 47.2538 6.20496 48.9651C6.97194 50.4704 8.19579 51.6942 9.70108 52.4612C11.4124 53.3332 13.6526 53.3332 18.133 53.3332Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSent);
export default __webpack_public_path__ + "static/media/status-sent.8beacf09c99853f25c9cb8efa8dc9b4f.svg";
export { ForwardRef as ReactComponent };